import { toast } from 'react-hot-toast';

export const notifications = {
  success: (title, description) => {
    toast.success(description ? `${title}: ${description}` : title);
  },

  error: (title, description) => {
    toast.error(description ? `${title}: ${description}` : title);
  },

  warning: (title, description) => {
    toast(description ? `${title}: ${description}` : title, {
      icon: '⚠️',
    });
  },

  info: (title, description) => {
    toast(description ? `${title}: ${description}` : title, {
      icon: 'ℹ️',
    });
  },

  default: (title, description) => {
    toast(description ? `${title}: ${description}` : title);
  },
};

// Predefined notifications for common use cases
export const commonNotifications = {
  loginSuccess: () =>
    notifications.success(
      "Welcome back!",
      "You have been logged in successfully."
    ),

  loginError: () =>
    notifications.error(
      "Invalid credentials",
      "Please check your email and password."
    ),

  saveSuccess: () =>
    notifications.success(
      "Saved successfully",
      "Your changes have been saved."
    ),

  saveError: () =>
    notifications.error(
      "Save failed",
      "There was an error saving your changes."
    ),

  deleteSuccess: () =>
    notifications.success("Deleted successfully", "The item has been removed."),

  deleteError: () =>
    notifications.error(
      "Delete failed",
      "There was an error deleting the item."
    ),

  copySuccess: () =>
    notifications.success(
      "Copied to clipboard",
      "The content has been copied to your clipboard."
    ),

  networkError: () =>
    notifications.error(
      "Network error",
      "Please check your internet connection and try again."
    ),

  validationError: () =>
    notifications.warning(
      "Validation error",
      "Please check the form and try again."
    ),

  analysisComplete: () =>
    notifications.success(
      "Analysis complete",
      "Your website analysis has finished successfully."
    ),

  invitationSent: () =>
    notifications.success(
      "Invitation sent",
      "Team invitation has been sent successfully."
    ),

  settingsUpdated: () =>
    notifications.success(
      "Settings updated",
      "Your preferences have been saved."
    ),
};
